import { render, staticRenderFns } from "./GoodsReceiveDetail.vue?vue&type=template&id=c8e79508&scoped=true"
import script from "./GoodsReceiveDetail.vue?vue&type=script&lang=js"
export * from "./GoodsReceiveDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodsReceiveDetail.vue?vue&type=style&index=0&id=c8e79508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e79508",
  null
  
)

export default component.exports